<script>
export default {
    props: ['data', 'show'],
    name: "artistInfo",
    data() {
        return {};
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="artist_info position_100" v-if="show">
        <div class="wrapper flex flex_column justify_center">
            <div class="info">
                <div class="btn_close top flex justify_center" @click="$emit('close')"></div>
                <div class="content">
                    <p class="title">{{ data.name }}</p>
                    <div class="text" v-html="$textToHtml(data.desc)"></div>
                    <div class="link" v-if="data.introduce"><a :href="data.introduce" target="_blank" download>下载艺术家介绍</a></div>
                    <template v-if="data.customer">
                        <p class="title">客户</p>
                        <div class="text" v-html="$textToHtml(data.customer)"></div>
                    </template>
                    <template v-if="data.honor">
                        <p class="title">荣誉</p>
                        <div class="text" v-html="$textToHtml(data.honor)"></div>
                    </template>
                </div>
                <div class="btn_close bottom flex justify_center" @click="$emit('close')"></div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.artist_info{
    background: rgba($color: #000000, $alpha: .5);
    position: fixed;
    z-index: 99;
    overflow-y: auto;
    padding: .2rem 0;
    @media only screen and (max-width: 750px) {
        padding: 1rem 0;
    }
}
.wrapper{
    width: 11.2rem;
    min-height: 100%;
    margin: 0 auto;
    @media only screen and (max-width: 750px) {
        width: 6.9rem;
    }
}
.info{
    background: #fff;
    .btn_close{
        height: .5rem;
        background: url('~@/assets/images/icon_close.png') no-repeat center/.16rem;
        cursor: pointer;
        &.top{
            border-bottom: 1px dashed #999;
        }
        &.bottom{
            border-top: 1px dashed #999;
        }
    }
    .content{
        padding: .8rem 1.4rem;
        font-size: .25rem;
        @media only screen and (max-width: 750px) {
            padding: .8rem .5rem;
            font-size: .28rem;
        }
        .title{
            text-align: center;
            font-size: .35rem;
            margin-bottom: .3rem;
            @media only screen and (max-width: 750px) {
                font-size: .32rem;
            }
        }
        .text{
            margin-bottom: .5rem;
            text-align: justify;
            text-align-last: center;
            line-height: 2;
            &:last-child{
                margin-bottom: 0;
            }
            @media only screen and (max-width: 750px) {
                color: #666;
            }
        }
        .link{
            font-size: .24rem;
            text-align: center;
            margin-bottom: .5rem;
            a{
                border-bottom: 1px solid var(--font_color);
            }
            @media only screen and (max-width: 750px) {
                font-size: .26rem;
            }
        }
    }
}
</style>